import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { previewToolConst } from '../../../../../constants/previewTool';
import { openPreviewPage } from '../../../../../util/helpers';
import TextField from '../../../../forms/TextField';

export default function Html() {
  const {
    watch,
  } = useFormContext();
  const watchHtml = watch('momentNativeAd.html');

  return(
    <Stack spacing={1}>
      <TextField
        name="momentNativeAd.autoHtml"
        label='Custom HTML (Optional)'
        multiline
        rows={5}
      />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="caption">
          <Button
            onClick={() => openPreviewPage(watchHtml)}
            disabled={!watchHtml}
            disableRipple
            type="button"
            variant="text"
            sx={{ padding: 0, "&:hover": { backgroundColor: "transparent" } }}
          >
            {previewToolConst.creativeButtonLabel}
          </Button>
        </Typography>
        <Typography variant="caption">
          <a
            href="https://github.com/ThinkNear/EngineeringWiki/wiki/Common-errors-in-XHTML-validation/" target="_blank"
            rel="noreferrer"
          >
            Common Errors
          </a>
        </Typography>
      </Stack>
    </Stack>
  )
}
